// extracted by mini-css-extract-plugin
export default {"label":"SuperCheckbox_label__wAVGp","checkbox":"SuperCheckbox_checkbox__vi1Vw"};